// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./cartridges/plugin_change2_product/cartridge/client/default/js/change2/CH2VirtualTryOn.js");
